<template>
  <div class="title" v-for="item in list"  :key="item.roleId">
    <div class="title-content">
      <van-icon class="icon" name="location-o" />
      <span class="title-text">{{ item.title }}</span>
    </div>
    <list-item-next :list="item.empList" />
  </div>
</template>

<script>
import ListItemNext from './ListItemNext.vue'
export default {
  name: 'ListItem',
  components: { ListItemNext },
  props: {
    list: {
      type: Array
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 14px;
  padding: 0 16px;
  margin-top: 16px;
  .title-content {
    font-weight: 600;
    font-size: 16px;
  }
}
.icon {
  margin-right: 2px;
}
</style>
